// class PriceRange extends HTMLElement{selectors={inputs:['input[type="number"]'],ranges:['input[type="range"]'],minRange:'[data-type="min-range"]',maxRange:'[data-type="max-range"]',minInput:'[data-type="min-input"]',maxInput:'[data-type="max-input"]'};constructor(){super(),this.domNodes=queryDomNodes(this.selectors,this),this.priceGap=parseInt(this.dataset.priceGap),this.priceMax=parseInt(this.dataset.priceMax),this.domNodes.inputs.forEach((e=>e.addEventListener("change",this.onInputChange.bind(this)))),this.domNodes.ranges.forEach((e=>e.addEventListener("input",this.onSliderChange.bind(this)))),this.setMinAndMaxValues()}onSliderChange(e){const t=e.currentTarget,a=t.dataset.type,{minInput:i,maxInput:s,minRange:n,maxRange:u}=(Number(t.value),this.domNodes);"min-range"===a&&(u.value-t.value>=this.priceGap?i.value=t.value:t.value=u.value-this.priceGap),"max-range"===a&&(t.value-n.value>=this.priceGap?s.value=t.value:t.value=Number(n.value)+Number(this.priceGap)),this.style.setProperty("--from",100*n.value/this.priceMax+"%"),this.style.setProperty("--to",100*u.value/this.priceMax+"%")}onInputChange(e){this.adjustToValidValues(e.currentTarget),this.setMinAndMaxValues()}setMinAndMaxValues(){const{minInput:e,maxInput:t}=this.domNodes;t.value&&e&&e.setAttribute("max",Number(t.value)-this.priceGap),e.value&&t&&t.setAttribute("min",Number(e.value)+this.priceGap),""===e.value&&t&&t.setAttribute("min",0),""===t.value&&e&&e.setAttribute("max",t.getAttribute("max"))}adjustToValidValues(e){const t=Number(e.value),a=Number(e.getAttribute("min")),i=Number(e.getAttribute("max"));t<a&&(e.value=a),t>i&&(e.value=i)}}customElements.define("price-range",PriceRange);

if (!customElements.get("price-range")) {

  class PriceRange extends HTMLElement {

    selectors = {
      inputs: ['input[type="number"]'],
      ranges: ['input[type="range"]'],
      minRange: '[data-type="min-range"]',
      maxRange: '[data-type="max-range"]',
      minInput: '[data-type="min-input"]',
      maxInput: '[data-type="max-input"]'
    };

    constructor() {
      super();

      this.domNodes = queryDomNodes(this.selectors, this);

      this.priceGap = parseInt(this.dataset.priceGap);
      this.priceMax = parseInt(this.dataset.priceMax);

      this.domNodes.inputs.forEach((e) =>
        e.addEventListener("change", this.onInputChange.bind(this))
      );

      this.domNodes.ranges.forEach((e) =>
        e.addEventListener("input", this.onSliderChange.bind(this))
      );

      this.setMinAndMaxValues();
    }

    onSliderChange(e) {

      const target = e.currentTarget;
      const type = target.dataset.type;

      const {
        minInput,
        maxInput,
        minRange,
        maxRange
      } = this.domNodes;

      if (type === "min-range") {

        if (maxRange.value - target.value >= this.priceGap) {
          minInput.value = target.value;
        } else {
          target.value = maxRange.value - this.priceGap;
        }
      }

      if (type === "max-range") {

        if (target.value - minRange.value >= this.priceGap) {
          maxInput.value = target.value;
        } else {
          target.value = Number(minRange.value) + Number(this.priceGap);
        }
      }

      this.style.setProperty(
        "--from",
        (100 * minRange.value / this.priceMax) + "%"
      );

      this.style.setProperty(
        "--to",
        (100 * maxRange.value / this.priceMax) + "%"
      );
    }

    onInputChange(e) {
      this.adjustToValidValues(e.currentTarget);
      this.setMinAndMaxValues();
    }

    setMinAndMaxValues() {

      const { minInput, maxInput } = this.domNodes;

      if (maxInput.value && minInput) {
        minInput.setAttribute(
          "max",
          Number(maxInput.value) - this.priceGap
        );
      }

      if (minInput.value && maxInput) {
        maxInput.setAttribute(
          "min",
          Number(minInput.value) + this.priceGap
        );
      }

      if (minInput.value === "" && maxInput) {
        maxInput.setAttribute("min", 0);
      }

      if (maxInput.value === "" && minInput) {
        minInput.setAttribute(
          "max",
          maxInput.getAttribute("max")
        );
      }
    }

    adjustToValidValues(input) {

      const value = Number(input.value);
      const min = Number(input.getAttribute("min"));
      const max = Number(input.getAttribute("max"));

      if (value < min) {
        input.value = min;
      }

      if (value > max) {
        input.value = max;
      }
    }
  }

  customElements.define("price-range", PriceRange);
}